import { toAbsoluteUrl } from "@/lib/imageUrl";
import SafeImg from "@/components/common/SafeImg";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { HOME_WRAP } from "./homeTheme";

/**
 * "Trusted By" — the client logos from `data.clients` on a slow, pausable marquee.
 * Logos are shown in a single consistent tile size, greyscale until hovered, and
 * are `object-contain` (never stretched). `mix-blend-multiply` drops the white
 * background of JPG logos into the page. The marquee stops for visitors who prefer
 * reduced motion (the row then scrolls by hand), and pauses on hover/focus.
 */
export default function ClientLogos({ data }) {
  const section = data?.clientsSection || {};
  const clients = (Array.isArray(data?.clients) ? data.clients : []).filter((c) => c.status !== false && c.logo).sort((a, b) => (a.order || 0) - (b.order || 0));
  if (!clients.length) return null;

  const Tile = ({ c, hidden }) => {
    const img = (
      <SafeImg fallback={<span className="text-center font-heading text-sm font-bold text-[#1A2F4A]/60">{c.name}</span>} src={toAbsoluteUrl(c.logo)} alt={hidden ? "" : `${c.name} logo`} loading="lazy" decoding="async" width="160" height="72" className="h-[72px] w-[160px] object-contain mix-blend-multiply opacity-60 [filter:grayscale(1)_brightness(1.08)] transition-[filter,opacity] duration-300 group-hover:opacity-100 group-hover:[filter:grayscale(0)_brightness(1.06)]" />
    );
    const cls = "group flex h-24 w-52 shrink-0 items-center justify-center px-6";
    return c.websiteUrl ? (
      <a href={c.websiteUrl} target="_blank" rel="noopener noreferrer" className={cls} tabIndex={hidden ? -1 : undefined} aria-hidden={hidden || undefined}>{img}</a>
    ) : (
      <div className={cls} aria-hidden={hidden || undefined}>{img}</div>
    );
  };

  return (
    <section className="border-y border-[#E4E9F2] bg-white py-16 lg:py-20" aria-labelledby="home-clients-title">
      <div className={HOME_WRAP}>
        <SectionHeader align="center" eyebrow={section.title || "Trusted By"} title={section.subtitle || "Our Esteemed Clients"} titleId="home-clients-title" className="mb-10 lg:mb-12 [&_h2]:!text-[28px] sm:[&_h2]:!text-[32px] lg:[&_h2]:!text-[38px]" />
      </div>
      <Reveal>
        <div className="home-marquee relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
          <div className="home-marquee-track flex w-max items-center">
            {clients.map((c, i) => <Tile key={`a-${i}`} c={c} />)}
            {clients.map((c, i) => <Tile key={`b-${i}`} c={c} hidden />)}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
